import { render, staticRenderFns } from "./companyPoliciesDocument.vue?vue&type=template&id=7eb3a036&scoped=true"
import script from "./companyPoliciesDocument.vue?vue&type=script&lang=js"
export * from "./companyPoliciesDocument.vue?vue&type=script&lang=js"
import style0 from "./companyPoliciesDocument.vue?vue&type=style&index=0&id=7eb3a036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb3a036",
  null
  
)

export default component.exports